/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Route`
};

const en_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerary`
};

const es_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario`
};

const fr_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Itinéraire`
};

const it_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario`
};

const nl_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Route`
};

const pt_search_tools__button__text = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_tools__button__text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_tools__button__text", locale)
	if (locale === "de") return de_search_tools__button__text(inputs)
	if (locale === "en") return en_search_tools__button__text(inputs)
	if (locale === "es") return es_search_tools__button__text(inputs)
	if (locale === "fr") return fr_search_tools__button__text(inputs)
	if (locale === "it") return it_search_tools__button__text(inputs)
	if (locale === "nl") return nl_search_tools__button__text(inputs)
	return pt_search_tools__button__text(inputs)
};